export default __webpack_public_path__ + "static/heroSectionLeftImage-be4a527245d6ccae5e21f13dcd93327b.webp";